import { NomenklatureInterface, Orientation, Sides, Width } from "../types/store";
import { ShelvingInterface } from "../useShelvingStore";

const calcWidthCount = (width: string | Width, sides: Sides[], shelving: ShelvingInterface, orientation: Orientation) =>
    sides.reduce((prev, side) => prev + shelving[side].nomenklature[orientation]?.[width as Width] ?? 0, 0);

export const calcTotalNomenclature = (
    shelving: ShelvingInterface,
    widthes: (string | Width)[]
): NomenklatureInterface => {
    const sides = Object.values(Sides);
    const orientations = Object.values(Orientation);

    const orientationsCount: NomenklatureInterface = orientations.reduce(
        (prev, orientation) => ({
            ...prev,
            [orientation]: widthes.reduce(
                (prev, width) => ({ ...prev, [width]: calcWidthCount(width, sides, shelving, orientation) }),
                {}
            ),
        }),
        {} as NomenklatureInterface
    );

    return {
        ...orientationsCount,
        connector: sides.reduce((prev, side) => prev + shelving[side].nomenklature.connector, 0),
    };
};
